const CORRELATION_ID_PATTERN = /^cor_[a-z0-9]{24,64}$/;

export function normalizeCorrelationId(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const normalized = value.trim().toLowerCase();
  return CORRELATION_ID_PATTERN.test(normalized) ? normalized : null;
}

export function createCorrelationId(): string {
  const cryptoApi = globalThis.crypto;
  if (cryptoApi?.randomUUID) {
    return `cor_${cryptoApi.randomUUID().replaceAll("-", "")}`;
  }
  if (cryptoApi?.getRandomValues) {
    const bytes = cryptoApi.getRandomValues(new Uint8Array(16));
    return `cor_${Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("")}`;
  }
  // Old embedded runtimes only. Timestamp plus two random draws keeps this
  // opaque without introducing a device or account identifier.
  return `cor_${Date.now().toString(36)}${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`
    .slice(0, 36)
    .padEnd(36, "0");
}

export function correlationIdFromHeaders(headers: Headers): string {
  return normalizeCorrelationId(headers.get("x-correlation-id")) ?? createCorrelationId();
}
